<template>
  <v-card v-if="visibleAlerts && visibleAlerts.length > 0" class="bjjlink-card" elevation="0">
    <v-card-text style="margin-left: 13px" v-if="!hideHeader">
      <v-icon>mdi-alert-outline</v-icon>
      {{ $t('message.alerts') }} ({{ visibleAlerts.length }})
    </v-card-text>
    <v-card-text class="pa-0">
      <v-list class="text-left" dense>
        <template v-for="(i, index) in visibleAlerts">
          <v-list-item :key="'alert_' + index" class="pl-0 pr-0">
            <v-list-item-action>
              <v-icon v-if="i.type == 'alert_missing_document'">mdi-file-sign</v-icon>
              <v-icon v-else-if="i.type == 'alert_cancellation_request'">mdi-account-cancel-outline</v-icon>
              <v-icon v-else-if="i.type == 'alert_pause_request'">mdi-pause-circle-outline</v-icon>
              <v-icon v-else-if="i.type == 'alert_no_image'">mdi-card-account-details-outline</v-icon>
              <v-icon v-else-if="i.type == 'alert_missing_info'">mdi-account-alert-outline</v-icon>
              <v-icon v-else>mdi-credit-card-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <span>{{ $t('message.' + i.type) }}</span>
              </v-list-item-title>
              <v-list-item-subtitle v-if="i.reason">
                {{ $t('message.reason') }}: {{ i.reason }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="i.text">
                <span v-if="i.type == 'alert_missing_info'">{{ $t('message.required_field_' + i.text) }}</span>
                <span v-else>{{ i.text }}</span>
                <span v-if="i.date">- {{ i.resolvable ? $t('message.requested') : $t('message.expired') }} {{
                  $d(new Date(i.date), 'month_day_year',
                    $i18n.locale)
                  }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn elevation="0" :icon="isSmallerDisplay() ? true : false"
                :outlined="isSmallerDisplay() ? false : true" v-allowed="'send_waiver'"
                v-if="i.type == 'alert_missing_document'" color="primary" @click="sendDocumentToMember(i.objectId)"
                small>
                <v-icon>mdi-cellphone-message</v-icon>
                <span v-if="!isSmallerDisplay()">{{ $t('message.send_document') }}</span>
              </v-btn>
              <v-btn :icon="isSmallerDisplay() ? true : false" :outlined="isSmallerDisplay() ? false : true"
                elevation="0" v-else-if="i.type == 'alert_no_image'" color="primary"
                @click="sendNoImageReminder(i.objectId)" small>
                <v-icon>mdi-cellphone-message</v-icon>
                <span v-if="!isSmallerDisplay()">{{ $t('message.send_reminder') }}</span>
              </v-btn>
              <v-btn :icon="isSmallerDisplay() ? true : false" :outlined="isSmallerDisplay() ? false : true"
                elevation="0" v-else-if="i.type == 'alert_missing_info' && !missingInfoSent" color="primary"
                @click="sendMissingInfoReminder(i.objectId)" small>
                <v-icon>mdi-cellphone-message</v-icon>
                <span v-if="!isSmallerDisplay()">{{ $t('message.send_reminder') }}</span>
              </v-btn>
              <v-btn :icon="isSmallerDisplay() ? true : false" :outlined="isSmallerDisplay() ? false : true"
                elevation="0" v-else-if="i.type == 'alert_membership_pending_payment'" color="primary"
                @click="sendPendingPaymentReminder(i.objectId)" small>
                <v-icon>mdi-cellphone-message</v-icon>
                <span v-if="!isSmallerDisplay()">{{ $t('message.send_reminder') }}</span>
              </v-btn>
              <v-btn :icon="isSmallerDisplay() ? true : false" :outlined="isSmallerDisplay() ? false : true"
                elevation="0" v-else-if="i.resolvable" color="success" :loading="resolving == i.objectId"
                @click="askToResolve(i)" small>
                <v-icon>mdi-check</v-icon>
                <span v-if="!isSmallerDisplay()">{{ $t('message.mark_as_done') }}</span>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="index + 1 < alerts.length" :key="index"></v-divider>
        </template>
      </v-list>
    </v-card-text>
    <v-dialog v-model="confirmDialog" max-width="80%">
      <v-card class="pa-2">
        <v-card-text>
          <h3>{{ $t("message.are_you_sure") }}</h3>
          <div v-if="pendingAlert" class="mt-2">
            {{ $t('message.' + pendingAlert.type) }}
            <span v-if="pendingAlert.reason"> - {{ pendingAlert.reason }}</span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn small elevation="0" color="success" class="black--text"
            :loading="resolving == (pendingAlert && pendingAlert.objectId)"
            @click="resolveRequest()">
            {{ $t("message.mark_as_done") }}
          </v-btn>
          <v-btn small elevation="0" class="outlined-btn" @click.stop="
            confirmDialog = false;
          pendingAlert = null;
          ">{{ $t("message.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
  <div v-else>
    <v-card-text class="text-center">
      <h2>
        <v-icon size="30" :color="themeColor('success')">mdi-check-circle-outline</v-icon>
        {{ $t('message.no_alerts') }}
      </h2>
    </v-card-text>
  </div>
</template>

<script>
import Api from "@/services/Api";

export default {
  props: ["alerts", "member", "hideHeader"],
  data() {
    return {
      missingInfoSent: false,
      //Cleared requests, hidden straight away rather than waiting for the
      //parent to refetch.
      resolvedIds: [],
      resolving: null,
      confirmDialog: false,
      pendingAlert: null,
    };
  },
  methods: {
    sendMissingInfoReminder(id) {
      Api()
        .post(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/reminder/missing_info/" +
          id
        )
        .then((response) => {
          if (response) {
            this.missingInfoSent = true;
            this.showAlert(
              "success",
              this.$t("message.sent")
            );
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    sendNoImageReminder(id) {
      Api()
        .post(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/reminder/no_image/" +
          id
        )
        .then((response) => {
          if (response) {
            this.showAlert(
              "success",
              this.$t("message.sent")
            );
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    sendPendingPaymentReminder(id) {
      Api()
        .post(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/reminder/transaction/" +
          id
        )
        .then((response) => {
          if (response) {
            this.showAlert(
              "success",
              this.$t("message.sent")
            );
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    askToResolve(alert) {
      this.pendingAlert = alert;
      this.confirmDialog = true;
    },
    resolveRequest() {
      if (!this.pendingAlert) return;
      const id = this.pendingAlert.objectId;
      this.resolving = id;
      Api()
        .patch(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/membership-requests/" +
          id +
          "/resolve"
        )
        .then((response) => {
          this.resolving = null;
          this.confirmDialog = false;
          this.pendingAlert = null;
          if (response) {
            this.resolvedIds.push(id);
            //So whoever owns the list can refresh its count.
            this.$emit("resolved", id);
            this.showAlert("success", this.$t("message.updated"));
          }
        })
        .catch((e) => {
          this.resolving = null;
          //The dialog stays open on a failure so the admin can try again
          //without hunting for the alert a second time.
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    sendDocumentToMember(id) {
      Api()
        .post(
          "documents/academy/" +
          this.$store.state.managedAcademy +
          "/templates/send/" +
          id,
          { users: [this.member], objectType: 'document' }
        )
        .then((response) => {
          if (response) {
            this.showAlert(
              "success",
              this.$t("message.sent_to_members", [response.data.total])
            );
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
  },
  created() { },
  computed: {
    visibleAlerts() {
      if (!this.alerts) return [];
      return this.alerts.filter(
        (a) => this.resolvedIds.indexOf(a.objectId) < 0,
      );
    },
  },
};
</script>

<style scoped></style>
